// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `/* ─── Project Compounds Custom Styles ─── */

.structure-thumb:hover {
  border-color: #3b82f6 !important;
  box-shadow: 0 2px 8px rgba(59,130,246,0.15), 0 0 0 2px rgba(59,130,246,0.1) !important;
}

/* Improve Datatable header styling */
.project-compounds-table .p-datatable-thead > tr > th {
  background: #f8fafc !important;
  color: #475569 !important;
  font-weight: 600 !important;
  font-size: 12px !important;
  text-transform: uppercase !important;
  letter-spacing: 0.3px !important;
  border-bottom: 2px solid #e2e8f0 !important;
}

.project-compounds-table .p-datatable-tbody > tr {
  transition: background 0.15s ease;
}

.project-compounds-table .p-datatable-tbody > tr:hover {
  background: #f1f5f9 !important;
}

.project-compounds-table .p-paginator {
  background: transparent !important;
  border-top: 1px solid #e8edf5 !important;
  padding-top: 12px !important;
}

.project-compounds-table .p-datatable-row-expansion {
  background: transparent !important;
}

/* ── Add Compound button inside SectionHeading ── */
.add-compound-btn {
  background: rgba(255,255,255,0.12) !important;
  border: 1px solid rgba(255,255,255,0.45) !important;
  color: #ffffff !important;
  border-radius: 8px !important;
  padding: 6px 14px !important;
  font-weight: 500 !important;
  font-size: 13px !important;
  backdrop-filter: blur(4px) !important;
  transition: all 0.2s ease !important;
  box-shadow: none !important;
}

.add-compound-btn:hover {
  background: rgba(255,255,255,0.22) !important;
  border-color: rgba(255,255,255,0.7) !important;
  box-shadow: 0 2px 12px rgba(255,255,255,0.15) !important;
}

.add-compound-btn:active {
  background: rgba(255,255,255,0.28) !important;
}

/* ── Add Activity button inside expand row ── */
.add-activity-btn {
  background: linear-gradient(135deg, #6366f1, #4f46e5) !important;
  border: none !important;
  color: #fff !important;
  border-radius: 6px !important;
  padding: 6px 12px !important;
  font-weight: 500 !important;
  font-size: 12px !important;
  box-shadow: 0 2px 6px rgba(99,102,241,0.2) !important;
  transition: all 0.2s ease !important;
}

.add-activity-btn:hover {
  box-shadow: 0 4px 12px rgba(99,102,241,0.35) !important;
  transform: translateY(-1px);
}

.add-activity-btn:active {
  transform: translateY(0);
  box-shadow: 0 1px 3px rgba(99,102,241,0.2) !important;
}

/* ── Structure thumbnail in expand row ── */
.structure-thumb-large:hover {
  border-color: #6366f1 !important;
  box-shadow: 0 4px 16px rgba(99,102,241,0.15) !important;
}

/* ── Activity data table ── */
.activity-table .p-datatable-thead > tr > th {
  background: #f8fafc !important;
  color: #64748b !important;
  font-weight: 600 !important;
  font-size: 11px !important;
  border-bottom: 1px solid #e2e8f0 !important;
}

.activity-table .p-datatable-tbody > tr {
  transition: background 0.12s ease;
  font-size: 12px !important;
}

.activity-table .p-datatable-tbody > tr:hover {
  background: #f1f5f9 !important;
}

.activity-table .p-datatable-tbody > tr > td {
  padding: 6px 8px !important;
}

/* ── Center table headers ── */
.project-compounds-table .p-datatable-thead > tr > th {
  text-align: center !important;
}

/* ── Halve sort icon size ── */
.project-compounds-table .p-sortable-column-icon {
  font-size: 7px !important;
}

/* ── Row resize handle ── */
.row-resize-handle {
  position: absolute;
  bottom: -3px;
  left: 0;
  right: 0;
  height: 6px;
  background: transparent;
  cursor: ns-resize;
  z-index: 5;
}

.row-resize-handle::after {
  content: '';
  position: absolute;
  left: 25%;
  right: 25%;
  top: 2px;
  height: 2px;
  background: transparent;
  border-radius: 2px;
  transition: background 0.15s;
}

.row-resize-handle:hover::after {
  background: #6366f1;
}

.row-resize-handle:active::after {
  background: #4f46e5;
  height: 3px;
}

/* ─── More actions (•••) button ─── */
.more-menu-btn {
  color: #fff !important;
  font-weight: 700 !important;
  border: none !important;
}
`, "",{"version":3,"sources":["webpack://./src/scene-pm/Projects/ProjectView/ProjectCompounds/ProjectCompounds.css"],"names":[],"mappings":"AAAA,4CAA4C;;AAE5C;EACE,gCAAgC;EAChC,sFAAsF;AACxF;;AAEA,qCAAqC;AACrC;EACE,8BAA8B;EAC9B,yBAAyB;EACzB,2BAA2B;EAC3B,0BAA0B;EAC1B,oCAAoC;EACpC,gCAAgC;EAChC,2CAA2C;AAC7C;;AAEA;EACE,iCAAiC;AACnC;;AAEA;EACE,8BAA8B;AAChC;;AAEA;EACE,kCAAkC;EAClC,wCAAwC;EACxC,4BAA4B;AAC9B;;AAEA;EACE,kCAAkC;AACpC;;AAEA,oDAAoD;AACpD;EACE,6CAA6C;EAC7C,mDAAmD;EACnD,yBAAyB;EACzB,6BAA6B;EAC7B,4BAA4B;EAC5B,2BAA2B;EAC3B,0BAA0B;EAC1B,qCAAqC;EACrC,oCAAoC;EACpC,2BAA2B;AAC7B;;AAEA;EACE,6CAA6C;EAC7C,8CAA8C;EAC9C,wDAAwD;AAC1D;;AAEA;EACE,6CAA6C;AAC/C;;AAEA,gDAAgD;AAChD;EACE,gEAAgE;EAChE,uBAAuB;EACvB,sBAAsB;EACtB,6BAA6B;EAC7B,4BAA4B;EAC5B,2BAA2B;EAC3B,0BAA0B;EAC1B,qDAAqD;EACrD,oCAAoC;AACtC;;AAEA;EACE,uDAAuD;EACvD,2BAA2B;AAC7B;;AAEA;EACE,wBAAwB;EACxB,qDAAqD;AACvD;;AAEA,4CAA4C;AAC5C;EACE,gCAAgC;EAChC,uDAAuD;AACzD;;AAEA,8BAA8B;AAC9B;EACE,8BAA8B;EAC9B,yBAAyB;EACzB,2BAA2B;EAC3B,0BAA0B;EAC1B,2CAA2C;AAC7C;;AAEA;EACE,iCAAiC;EACjC,0BAA0B;AAC5B;;AAEA;EACE,8BAA8B;AAChC;;AAEA;EACE,2BAA2B;AAC7B;;AAEA,+BAA+B;AAC/B;EACE,6BAA6B;AAC/B;;AAEA,+BAA+B;AAC/B;EACE,yBAAyB;AAC3B;;AAEA,4BAA4B;AAC5B;EACE,kBAAkB;EAClB,YAAY;EACZ,OAAO;EACP,QAAQ;EACR,WAAW;EACX,uBAAuB;EACvB,iBAAiB;EACjB,UAAU;AACZ;;AAEA;EACE,WAAW;EACX,kBAAkB;EAClB,SAAS;EACT,UAAU;EACV,QAAQ;EACR,WAAW;EACX,uBAAuB;EACvB,kBAAkB;EAClB,4BAA4B;AAC9B;;AAEA;EACE,mBAAmB;AACrB;;AAEA;EACE,mBAAmB;EACnB,WAAW;AACb;;AAEA,sCAAsC;AACtC;EACE,sBAAsB;EACtB,2BAA2B;EAC3B,uBAAuB;AACzB","sourcesContent":["/* ─── Project Compounds Custom Styles ─── */\n\n.structure-thumb:hover {\n  border-color: #3b82f6 !important;\n  box-shadow: 0 2px 8px rgba(59,130,246,0.15), 0 0 0 2px rgba(59,130,246,0.1) !important;\n}\n\n/* Improve Datatable header styling */\n.project-compounds-table .p-datatable-thead > tr > th {\n  background: #f8fafc !important;\n  color: #475569 !important;\n  font-weight: 600 !important;\n  font-size: 12px !important;\n  text-transform: uppercase !important;\n  letter-spacing: 0.3px !important;\n  border-bottom: 2px solid #e2e8f0 !important;\n}\n\n.project-compounds-table .p-datatable-tbody > tr {\n  transition: background 0.15s ease;\n}\n\n.project-compounds-table .p-datatable-tbody > tr:hover {\n  background: #f1f5f9 !important;\n}\n\n.project-compounds-table .p-paginator {\n  background: transparent !important;\n  border-top: 1px solid #e8edf5 !important;\n  padding-top: 12px !important;\n}\n\n.project-compounds-table .p-datatable-row-expansion {\n  background: transparent !important;\n}\n\n/* ── Add Compound button inside SectionHeading ── */\n.add-compound-btn {\n  background: rgba(255,255,255,0.12) !important;\n  border: 1px solid rgba(255,255,255,0.45) !important;\n  color: #ffffff !important;\n  border-radius: 8px !important;\n  padding: 6px 14px !important;\n  font-weight: 500 !important;\n  font-size: 13px !important;\n  backdrop-filter: blur(4px) !important;\n  transition: all 0.2s ease !important;\n  box-shadow: none !important;\n}\n\n.add-compound-btn:hover {\n  background: rgba(255,255,255,0.22) !important;\n  border-color: rgba(255,255,255,0.7) !important;\n  box-shadow: 0 2px 12px rgba(255,255,255,0.15) !important;\n}\n\n.add-compound-btn:active {\n  background: rgba(255,255,255,0.28) !important;\n}\n\n/* ── Add Activity button inside expand row ── */\n.add-activity-btn {\n  background: linear-gradient(135deg, #6366f1, #4f46e5) !important;\n  border: none !important;\n  color: #fff !important;\n  border-radius: 6px !important;\n  padding: 6px 12px !important;\n  font-weight: 500 !important;\n  font-size: 12px !important;\n  box-shadow: 0 2px 6px rgba(99,102,241,0.2) !important;\n  transition: all 0.2s ease !important;\n}\n\n.add-activity-btn:hover {\n  box-shadow: 0 4px 12px rgba(99,102,241,0.35) !important;\n  transform: translateY(-1px);\n}\n\n.add-activity-btn:active {\n  transform: translateY(0);\n  box-shadow: 0 1px 3px rgba(99,102,241,0.2) !important;\n}\n\n/* ── Structure thumbnail in expand row ── */\n.structure-thumb-large:hover {\n  border-color: #6366f1 !important;\n  box-shadow: 0 4px 16px rgba(99,102,241,0.15) !important;\n}\n\n/* ── Activity data table ── */\n.activity-table .p-datatable-thead > tr > th {\n  background: #f8fafc !important;\n  color: #64748b !important;\n  font-weight: 600 !important;\n  font-size: 11px !important;\n  border-bottom: 1px solid #e2e8f0 !important;\n}\n\n.activity-table .p-datatable-tbody > tr {\n  transition: background 0.12s ease;\n  font-size: 12px !important;\n}\n\n.activity-table .p-datatable-tbody > tr:hover {\n  background: #f1f5f9 !important;\n}\n\n.activity-table .p-datatable-tbody > tr > td {\n  padding: 6px 8px !important;\n}\n\n/* ── Center table headers ── */\n.project-compounds-table .p-datatable-thead > tr > th {\n  text-align: center !important;\n}\n\n/* ── Halve sort icon size ── */\n.project-compounds-table .p-sortable-column-icon {\n  font-size: 7px !important;\n}\n\n/* ── Row resize handle ── */\n.row-resize-handle {\n  position: absolute;\n  bottom: -3px;\n  left: 0;\n  right: 0;\n  height: 6px;\n  background: transparent;\n  cursor: ns-resize;\n  z-index: 5;\n}\n\n.row-resize-handle::after {\n  content: '';\n  position: absolute;\n  left: 25%;\n  right: 25%;\n  top: 2px;\n  height: 2px;\n  background: transparent;\n  border-radius: 2px;\n  transition: background 0.15s;\n}\n\n.row-resize-handle:hover::after {\n  background: #6366f1;\n}\n\n.row-resize-handle:active::after {\n  background: #4f46e5;\n  height: 3px;\n}\n\n/* ─── More actions (•••) button ─── */\n.more-menu-btn {\n  color: #fff !important;\n  font-weight: 700 !important;\n  border: none !important;\n}\n"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
export default ___CSS_LOADER_EXPORT___;
